/**
 * Created by dx.yang on 2017/3/20.
 */


import { Message } from '@king-design/vue-legacy';

export default {
    send(message, type = 'success') {
        if (type === 'success') {
            Message.success(message);
        } else {
            Message.error(message);
        }
    }
};
